
(function () {
  function initCollectionTabs(root = document) {
    const sections = [];

    if (
      root.matches &&
      root.matches('.collections-with-tabs')
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(
        ...root.querySelectorAll('.collections-with-tabs')
      );
    }

    sections.forEach((section) => {
      // Prevent duplicate event listeners
      if (section.dataset.tabsInitialized === 'true') {
        return;
      }

      section.dataset.tabsInitialized = 'true';

      const navigationItems = section.querySelectorAll(
        '.tabs-navigation-item'
      );

      const navigationSelect = section.querySelector(
        '.tabs-navigation-select'
      );

      const tabContents = section.querySelectorAll(
        '.product-grid'
      );

      function activateTab(tabId) {
        if (!tabId) return;

        navigationItems.forEach((item) => {
          item.classList.toggle(
            'active',
            item.dataset.tab === tabId
          );
        });

        tabContents.forEach((content) => {
          content.classList.toggle(
            'active',
            content.dataset.tabId === tabId
          );
        });

        if (navigationSelect) {
          navigationSelect.value = tabId;
          navigationSelect.classList.add('active');
        }
      }

      navigationItems.forEach((item) => {
        item.addEventListener('click', function () {
          activateTab(item.dataset.tab);
        });

        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activateTab(item.dataset.tab);
          }
        });
      });

      if (navigationSelect) {
        navigationSelect.addEventListener('change', function () {
          activateTab(navigationSelect.value);
        });
      }
    });
  }

  // Initialise once on page load
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initCollectionTabs();
      },
      { once: true }
    );
  } else {
    initCollectionTabs();
  }

  // Initialise newly loaded Shopify sections
  document.addEventListener('shopify:section:load', function (event) {
    initCollectionTabs(event.target);
  });
})();
